<template>
    <div class="page">
        <div class="top-header">
            <div>
                <div class="title">牛指积分</div>
                <div class="score">
                    <span> {{ sorce }}</span
                    ><span class="rownum">（ 排名：{{ rownum }} ）</span>
                </div>
            </div>
            <div class="goGz" @click="goGz()">点击查看积分规则</div>
        </div>
        <div class="list">
            <div class="item">
                <div>分数</div>
                <div>时间</div>
                <div>操作</div>
            </div>
            <div class="item" v-for="item in list" :key="item.info_id">
                <div>{{ item.score }}</div>
                <div>{{ item.ctime }}</div>
                <div>{{ item.credit_title }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import userCenterService from "../../service/user-center.service";
    export default {
        name: "integral-detail",
        data() {
            return {
                sorce: 0,
                rownum: 0,
                list: [],
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                userCenterService.getNiuzhiScoreList().then((res) => {
                    this.sorce = res.data.score_num;
                    this.rownum = res.data.rownum;
                    this.list = res.data.list;
                });
            },
            goGz() {
                location.href =
                    "http://daoda1997.daoda1997.cn/index.php?s=/Home/WxUserCenter/score_rules";
            },
        },
    };
</script>

<style lang="scss" scoped src="./integral-detail.scss"></style>
